<template>
  <div class="wrapper">
    <!-- 見出し -->
    <h3 class="heading">
      他の支部の自由項目を利用する（共有設定）
    </h3>

    <!-- フォーム -->
    <el-form :inline="true">
      <el-form-item label="得意先コード:">
        <el-input
          v-model="localSourceClientGroupId"
          size="small"
        />
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          size="small"
          @click="submit"
        >
          送 信
        </el-button>
      </el-form-item>
      <el-form-item>
        <el-button
          v-if="isSetConfigSource"
          type="text"
          @click="confirmRelease"
        >
          共有設定を解除
        </el-button>
      </el-form-item>
    </el-form>

    <!-- 注意事項 -->
    <p class="caption">
      <span class="required">※</span> 共有設定中は「自由項目の設定」は行えません
    </p>
  </div>
</template>

<script>
export default {
  name: "AdminOrderCustomFieldConfigSource",
  props: {
    sourceClientGroupId: String,
    isSetConfigSource: Boolean,
  },
  data () {
    return {
    };
  },
  computed: {
    localSourceClientGroupId: {
      get () {
        return this.sourceClientGroupId;
      },
      set (value) {
        this.$emit("update:sourceClientGroupId", value);
      },
    },
  },
  watch: {
  },
  created () {
  },
  mounted () {
  },
  methods: {
    submit () {
      const { sourceClientGroupId } = this;

      this.$emit("updateConfigSource", sourceClientGroupId);
    },

    confirmRelease () {
      if (!window.confirm("共有設定を解除してもよろしいですか？")) {
        return;
      }

      this.$emit("updateConfigSource", null);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.wrapper {
  margin: 12px 15px 15px;
  padding: 12px 15px 15px;
  // background-color: $background-gray-light;
  // border-radius: 8px;

  .heading {
    margin-block-start: 0;
    margin-block-end: 12px;

    &.no-margin {
      margin-block-end: 0;
    }
  }

  .el-form-item {
    margin-bottom: 12px;
  }

  .caption {
    margin: 0;
    font-size: 12.5px;

    .required {
      color: #ff0000;
    }
  }
}
</style>
